module.exports = __webpack_public_path__ + "img/person_1.db912d61.jpeg";